/**
 * Created by Administrator on 2019/10/7.
 */
import { request, requestFile,requestNew } from '../utils/request'
import serviceInterface from '../api/serviceInterface'


/**
 * 获取用户充值历史
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const getChargeList = (params) => {
    return request({
        url: serviceInterface.recharge.cradChargeList,
        params: params
    })
}


/**
 * 根据用户信息进行充值
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const doCharge = (params) => {
    return request({
        url: serviceInterface.recharge.cradCharge,
        params: params
    })
}

/**
 * 根据用户信息进行充值
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const paySuccess = (params) => {
    return request({
        url: serviceInterface.recharge.paySuccess,
        params: params
    })
}

/**
 * 根据用户信息进行vip开通
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const vipPaySuccess = (params) => {
    return request({
        url: serviceInterface.recharge.vipPaySuccess,
        params: params
    })
}

/**
 * vip 充值记录
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const vipChargeList = (params) => {
    return request({
        url: serviceInterface.recharge.vipChargeList,
        params: params
    })
}

/**
 * 根据用户余额进行vip开通
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const vipYePaySuccess = (params) => {
    return request({
        url: serviceInterface.recharge.vipYePaySuccess,
        params: params
    })
}
/**
 * 根据获取验证码
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const getImageCode = (params) => {
    return request({
        url: serviceInterface.recharge.cardImage,
        params: params,
        method:'get'
    })
}

/**
 * 使用余额购买识图次数
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
 export const findTimesPay = (params) => {
    return request({
      url: serviceInterface.recharge.findTimesPay,
      params: params,
    });
  };
  
  /**
   * 进行图搜
   * @param params
   * @returns {*|Promise<unknown>|undefined}
   */
  export const findByImageUrls = (params) => {
    return requestNew({
      url: serviceInterface.recharge.findByImageUrls,
      params: params,
      isShow: "1",
    });
  };
  
  /**
   * 使用余额购买识图次数的订单列表
   * @param params
   * @returns {*|Promise<unknown>|undefined}
   */
  export const findTimesList = (params) => {
    return request({
      url: serviceInterface.order.findTimesList,
      params: params,
    });
  };
  
  /**
   * 使用余额购买识图次数的订单列表
   * @param params
   * @returns {*|Promise<unknown>|undefined}
   */
  export const findOrderList = (params) => {
    return request({
      url: serviceInterface.order.findOrderList,
      params: params,
    });
  };
  
  /**
   * 使用余额购买识图次数的订单列表
   * @param params
   * @returns {*|Promise<unknown>|undefined}
   */
  export const uploadLocalFile = (params) => {
    return requestFile({
      url: serviceInterface.recharge.uploadFile,
      formdata: params,
    });
  };